<div class="certification-asssignment" *ngIf="reportData != undefined && translationLoaded">
    <div class="container">
        <div class="header">
            <div class="header-img">
                <img src="/assets/icons/group-4454.svg">
            </div>
            <div class="header-text">
                <h2>{{headerText}}</h2>
                <p>{{summaryText}}</p>
            </div>

        </div>
        <div class="table">
            <table>
                <th (click)="setSortField('moduleAssignmentName')" class="lg-header"
                    [class.sort]="sortField === 'moduleAssignmentName'">{{'reporting.ASSIGNMENT' | transloco}} <img [src]="sortIcon"
                        *ngIf="sortField === 'moduleAssignmentName'">
                </th>
                <th (click)="setSortField('moduleName')" class="module-header"
                    [class.sort]="sortField === 'moduleName'">{{'reporting.MODULE' | transloco}} <img [src]="sortIcon"
                        *ngIf="sortField === 'moduleName'">
                </th>
                <th (click)="setSortField('completed.percentage')" class="sm-header"
                    [class.sort]="sortField === 'completed.percentage'">% {{'reporting.CERTIFIED' | transloco}} <img [src]="sortIcon"
                        *ngIf="sortField === 'completed.percentage'">
                </th>
                <th class="sm-header assigned-count" (click)="setSortField('userAssignmentCount')"
                    [class.sort]="sortField === 'userAssignmentCount'"># {{'reporting.ASSIGNED' | transloco}} <img class="img"
                        src="/assets/icons/info-circle-grey.svg"
                        (click)="openTooltip($event, 'bottom', 'userAssignmentCount', 320, 60); $event.stopPropagation();">
                    <img [src]="sortIcon" *ngIf="sortField === 'userAssignmentCount'">
                </th>
                <th class="sm-header not-started" (click)="setSortField('notStarted.count')"
                    [class.sort]="sortField === 'notStarted.count'">{{'reporting.NOT_STARTED' | transloco}} <img class="img"
                        src="/assets/icons/info-circle-grey.svg"
                        (click)="openTooltip($event, 'bottom', 'notStarted', 320, 60); $event.stopPropagation();">
                    <img [src]="sortIcon" *ngIf="sortField === 'notStarted.count'">
                </th>
                <th (click)="setSortField('inProgress.count')" class="sm-header in-progress"
                    [class.sort]="sortField === 'inProgress.count'">{{'reporting.IN_PROGRESS' | transloco}} <img class="img"
                        src="/assets/icons/info-circle-grey.svg"
                        (click)="openTooltip($event, 'bottom', 'inProgress', 320, 60); $event.stopPropagation();">
                    <img [src]="sortIcon" *ngIf="sortField === 'inProgress.count'">
                </th>
                <th (click)="setSortField('completed.count')" class="sm-header certified"
                    [class.sort]="sortField === 'completed.count'">{{'reporting.CERTIFIED' | transloco}} <img class="img"
                        src="/assets/icons/info-circle-grey.svg"
                        (click)="openTooltip($event, 'bottom', 'certified', 320, 60); $event.stopPropagation();">
                    <img [src]="sortIcon" *ngIf="sortField === 'completed.count'">
                </th>
                <th (click)="setSortField('dueDate')" class="md-header" [class.sort]="sortField === 'dueDate'">{{'reporting.DUE_DATE' | transloco}}
                    <img [src]="sortIcon" *ngIf="sortField === 'dueDate'">
                </th>
                <tr *ngFor="let details of reportData.moduleAssignmentsDetail">
                    <ng-container *ngIf="details?.visible">
                        <td>
                            <div class="assignment-container">
                                <div class="wrapper">
                                    <div class="assignment-name" [ngClass]="{'expired-assignment': isExpired(details)}">
                                        {{details.moduleAssignmentName}}</div>
                                    <div class="days-left" *ngIf="!isExpired(details)">{{'reporting.ASSIGNMENT_ENDS_IN' | transloco}}
                                        {{details.daysLeft}} {{'reporting.DAYS' | transloco}}.</div>
                                    <div class="expired" *ngIf="isExpired(details)">{{'reporting.ASSIGNMENT_CLOSED' | transloco}} {{
                                        getPositiveNumber(details) }} {{'reporting.DAYS_AGO' | transloco}}.</div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="module-container" (click)="navigateToRoute(details)">
                                <div class="module-name">{{details.moduleName}}</div>
                                <div>
                                    <img src="/assets/icons/arrow/arrow-narrow-up-right-blue.svg">
                                </div>
                            </div>
                        </td>
                        <td>
                            <ng-container *ngIf="details.completed; else noData">
                                <div class="certified-no">
                                {{details.completed.percentage}}%
                                <mat-progress-bar mode="determinate" class="progress-bar"
                                    [value]="details.completed.percentage"></mat-progress-bar>
                                </div>
                            </ng-container>
                            <ng-template #noData>
                                <div class="no-data">-</div>
                            </ng-template>
                            </td>
                        <td>
                            <div class="assigned">
                                {{details.userAssignmentCount}}
                            </div>
                        </td>
                        <td>
                            <div [ngClass]="{'users-no': details.notStarted.count > 0, 'assigned': details.notStarted.count <= 0}"
                                (click)="details.notStarted.count > 0 && openModal(details.moduleAssignmentUuid, 'NOT_STARTED', details.notStarted.count, details.notStarted.percentage, details.moduleAssignmentName)">
                                {{details.notStarted.count}}
                                <img *ngIf="details.notStarted.showAlert" src="/assets/icons/alert-circle-lg.svg">
                                <img *ngIf="details.notStarted.count > 0" class="view-modal"
                                    src="/assets/icons/qnt-view-in-modal-pop.svg">
                            </div>
                        </td>
                        <td>
                            <div [ngClass]="{'users-no': details.inProgress.count > 0, 'assigned': details.inProgress.count <= 0}"
                                (click)="details.inProgress.count > 0 && openModal(details.moduleAssignmentUuid, 'IN_PROGRESS', details.inProgress.count, details.inProgress.percentage, details.moduleAssignmentName)">
                                {{details.inProgress.count}}
                                <img *ngIf="details.inProgress.showAlert" src="/assets/icons/alert-circle-lg.svg">
                                <img *ngIf="details.inProgress.count > 0" class="view-modal"
                                    src="/assets/icons/qnt-view-in-modal-pop.svg">
                            </div>
                        </td>
                        <td>
                            <div *ngIf="details.completed; else noData"
                                [ngClass]="{'users-no': details.completed.count > 0, 'assigned': details.completed.count <= 0}"
                                (click)="details.completed.count > 0 && openModal(details.moduleAssignmentUuid, 'COMPLETED', details.completed.count, details.completed.percentage, details.moduleAssignmentName)">
                                {{details.completed.count}}
                                <img *ngIf="details.completed.count > 0" class="view-modal"
                                src="/assets/icons/qnt-view-in-modal-pop.svg">
                            </div>
                            <ng-template #noData>
                                <div class="no-data">-</div>
                            </ng-template>
                            </td>
                        <td>
                            <div class="due-date">
                                <div>{{details.dueDate}}</div>
                                <!-- <div class="details">Details 
                                    <img class="bk-arrow" src="/assets/icons/arrow/arrow-narrow-up-right.svg">
                                    <img class="blue-arrow" src="/assets/icons/arrow/arrow-narrow-up-right-blue.svg">
                                </div> -->
                            </div>
                        </td>

                    </ng-container>
                </tr>


            </table>
            <div class="loader" *ngIf="oldDataLoading">
                <app-three-dots-blinking></app-three-dots-blinking>
            </div>
        </div>

        <div class="older-assignments">
            <p>{{toggleString}}</p>
            <div *ngIf="remainingAssignments > 0" (click)="toggleOldAssignments(); fetchOldAssignments()" class="cta"
                [ngClass]="{'disabled': oldDataLoading}">{{ctaText}} <img [src]="ctaImg"></div>

        </div>
    </div>
</div>